import { render, staticRenderFns } from "./PersonHome.vue?vue&type=template&id=5d53dd88"
import script from "./PersonHome.vue?vue&type=script&lang=js"
export * from "./PersonHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports